module.exports = __webpack_public_path__ + "static/media/pic8.d306ae02.png";